<template>
  <div class="pull-down-wrapper">
    <div class="input-wrap">
      <div class="search" v-if="!selectorVisible" @click="handleShowDialog">
        <el-input
          v-model="selectedLabel"
          @clear="handleClear"
          placeholder="请输入"
          clearable
        ></el-input>
      </div>
      <div class="search" v-if="selectorVisible">
        <el-input
          v-model="searchKeyword"
          @input="handleSearch"
          placeholder="请输入"
          clearable
          ref="search-input"
        ></el-input>
      </div>
    </div>
    <div
      class="selector-shadow"
      v-show="selectorVisible"
      @click="handleShadowClose"
    ></div>
    <div
      class="selector-wrap"
      v-show="selectorVisible"
      :style="`left:${pulldownX}px;top:${pulldownY}px;`"
    >
      <span class="arrow"></span>
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeTab === 'courseSet' }"
          @click="
            () => {
              activeTab = 'courseSet';
              handleSearch();
            }
          "
        >
          课程套餐
        </div>
        <div
          class="tab"
          :class="{ active: activeTab === 'productService' }"
          @click="
            () => {
              activeTab = 'productService';
              handleSearch();
            }
          "
        >
          物品服务
        </div>
      </div>
      <div class="list" v-show="activeTab === 'courseSet'">
        <div
          class="item"
          v-for="(item, index) in courseSetList"
          :class="{ selected: item.selected }"
          :key="item.course_id"
          @click="handleSelect(item, index)"
        >
          {{ item.title }}<i class="el-icon-check"></i>
        </div>
        <div class="no-data" v-show="courseSetList.length === 0">暂无数据</div>
      </div>
      <div class="list" v-show="activeTab === 'productService'">
        <div
          class="item"
          v-for="(item, index) in productServiceList"
          :class="{ selected: item.selected }"
          :key="item.product_id"
          @click="handleSelect(item, index)"
        >
          {{ item.title }}<i class="el-icon-check"></i>
        </div>
        <div class="no-data" v-show="productServiceList.length === 0">
          暂无数据
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSelectCourseList } from "@/api/globalSearch";
import { getProductListApi } from "@/api/product";
export default {
  // originType：源数据类型，1课程2物品3服务
  props: ["originType", "originId", "originLabel"],
  data() {
    return {
      searchKeyword: "",
      selectedLabel: "",
      selectedType: 0,
      selectedId: 0,
      activeTab: "courseSet",
      courseSetList: [],
      productServiceList: [],
      selectorVisible: false,
      pulldownX: 0,
      pulldownY: 0,
    };
  },
  watch: {
    originId: {
      handler() {
        if (this.originType && this.originId && this.originLabel) {
          this.selectedLabel = this.originLabel;
          this.selectedType = this.originType;
          this.selectedId = this.originId;
          if (this.originType === 1) {
            this.activeTab = "courseSet";
          } else {
            this.activeTab = "productService";
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleShowDialog(e) {
      if (e.target && e.target.nodeName !== "I") {
        this.pulldownX = e.pageX - e.offsetX;
        this.pulldownY = e.pageY - e.offsetY + 42;
        this.selectorVisible = true;
        this.$nextTick(() => {
          this.$refs["search-input"].focus();
          this.handleSearch();
        });
      }
    },
    handleClear() {
      this.selectedLabel = "";
      this.selectedType = "";
      this.selectedId = "";
      this.selectorVisible = false;
      this.emit();
    },
    emit() {
      this.$emit("update:originId", this.selectedId);
      this.$emit("update:originType", this.selectedType);
      this.$emit("update:originLabel", this.selectedLabel);
      this.$emit("change");
    },
    handleSearch() {
      if (this.activeTab === "courseSet") {
        getSelectCourseList({
          page: 1,
          page_size: 50,
          title: this.searchKeyword || "",
        }).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((item) => {
              item.selected = this.selectedId === item.course_id;
            });
            this.courseSetList = res.data.list;
          }
        });
      }
      if (this.activeTab === "productService") {
        getProductListApi({
          page: 1,
          page_size: 50,
          title: this.searchKeyword || "",
        }).then((res) => {
          if (res.error_code === 0) {
            res.data.list.map((item) => {
              item.selected = this.selectedId === item.product_id;
            });
            this.productServiceList = res.data.list;
          }
        });
      }
    },
    handleSearchFocus() {
      this.searchKeyword = "";
      this.handleSearch();
    },
    handleSelect(data, index) {
      // 选中
      if (this.activeTab === "courseSet") {
        this.selectedId = data.course_id;
        this.selectedType = 1;
        this.selectedLabel = data.title;
      } else {
        this.selectedId = data.product_id;
        this.selectedType = data.category_id === 1 ? 2 : 3;
        this.selectedLabel = data.title;
      }
      this.handleShadowClose();
      this.emit();
    },
    handleShadowClose() {
      this.selectorVisible = false;
      this.searchKeyword = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.pull-down-wrapper {
  position: relative;
  width: 100%;
  /deep/.input-wrap {
    display: flex;
    border: 1px solid #e7e8ea;
    border-radius: 4px;
    height: 28px;
    .selected {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .item {
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        line-height: 18px;
        height: 18px;
        margin: 4px 0 0 6px;
        padding: 0 4px;
        display: inline-block;
        &:first-child {
          margin-right: 12px;
        }
        i {
          cursor: pointer;
          font-size: 14px;
          color: #e1e1e1;
          margin: 2px 0 0 6px;
          vertical-align: top;
        }
      }
    }
    .search {
      flex: 1;
      min-width: 80px;
      position: relative;
      .el-input {
        .el-input__inner {
          border: none;
          line-height: 28px;
          height: 28px;
        }
      }
    }
  }
  .selector-shadow {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2000;
  }
  .selector-wrap {
    position: fixed;
    width: 180px;
    z-index: 2001;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    .arrow {
      left: 35px;
      top: -6px;
      border-top-width: 0;
      border-bottom-color: #ebeef5;
      border-width: 6px;
      filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
      position: absolute;
      display: block;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
      &::after {
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        content: " ";
        border-width: 6px;
        top: -5px;
        margin-left: -6px;
        border-top-width: 0;
        border-bottom-color: #fff;
      }
    }
    .tabs {
      display: flex;
      border-bottom: 1px solid #ebeef5;
      line-height: 40px;
      .tab {
        text-align: center;
        flex: 1;
        color: #5c5d5e;
        font-size: 13px;
        cursor: pointer;
        &.active {
          color: #07d1aa;
        }
      }
    }
    .list {
      padding: 5px 0;
      max-height: 200px;
      overflow: hidden auto;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      &::-webkit-scrollbar-button {
      }
      .item {
        padding: 0 20px;
        color: #5c5d5e;
        font-size: 12px;
        line-height: 28px;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        i {
          display: none;
        }
        &:hover {
          background-color: #f5f7fa;
          color: #07d1aa;
        }
        &.selected {
          background-color: #f5f7fa;
          color: #07d1aa;
          i {
            display: inline-block;
          }
        }
      }
    }
    .no-data {
      text-align: center;
      color: #5c5d5e;
      font-size: 12px;
      line-height: 36px;
    }
  }
}
</style>
